import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { announceList, announceListNew, delAnnounce, delAnnounceNew, sendAnnounce, userChannelList } from "@/api/gmtool/packageCode";
import addCode from "./components/add.vue";
import coverAnnounce from "./components/coverAnnounce.vue";
import richTextDetails from "./components/richTextDetails.vue";
import { gmTool } from "@/mixins/index";
export default {
  name: "announcementList",
  components: {
    addCode: addCode,
    richTextDetails: richTextDetails,
    coverAnnounce: coverAnnounce
  },
  mixins: [gmTool],
  data: function data() {
    return {
      advanced: false,
      dialog: false,
      total: 0,
      list: [],
      paramsData: {
        page: 1,
        start_time: "",
        end_time: ""
      },
      value2: [],
      selsString: "",
      TopLevelNot: true,
      channelList: []
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getserverList();

            case 2:
              _this.getList();

              _this.$store.state.d2admin.serchSelect.searchgames;

              _this.checkMobile();

              _this.getChannel();

              window.addEventListener('resize', _this.handleResize);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.checkMobile();
    },
    getChannel: function getChannel() {
      var _this2 = this;

      userChannelList({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this2.channelList = res.data;
        }
      });
    },
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    switchSerive: function switchSerive() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.currentPage = 1;
                _context2.next = 3;
                return _this3.getserverList();

              case 3:
                _this3.getList();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var list = e.map(function (item) {
        return item.id;
      });
      this.selsString = list.toString();
    },
    getList: function getList() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var list, listB;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.paramsData.start_time = _this4.value2 ? _this4.value2[0] : "";
                _this4.paramsData.end_time = _this4.value2 ? _this4.value2[1] : "";
                _this4.reqLoading = true;
                list = [];
                _context3.next = 6;
                return announceListNew(_this4.paramsData);

              case 6:
                listB = _context3.sent;
                listB.data.result.map(function (item, index) {
                  item.type = "new";
                  var d = item.data[0];
                  listB.data.result[index] = _objectSpread(_objectSpread({}, d), listB.data.result[index]);
                });
                list = _toConsumableArray(listB.data.result);
                list.map(function (item) {
                  var rawChannels = [].concat(_toConsumableArray(item.channel ? item.channel.split(",") : []), _toConsumableArray(item.channel_list ? item.channel_list.split(",") : [])); // 2. 去重并过滤无效空值

                  var uniqueChannels = Array.from(new Set(rawChannels)).map(function (id) {
                    return id.trim();
                  }).filter(function (id) {
                    return id && id !== "-1";
                  }); // 3. 映射为 channel_name，未匹配到则显示 ID

                  item.formattedChannels = uniqueChannels.map(function (id) {
                    // 支持按 channel_mark 或 id 进行匹配，去除前后空格
                    var target = _this4.channelList.find(function (c) {
                      return c.channel_mark == id.trim() || c.id == id.trim();
                    });

                    return target ? target.channel_name : id;
                  }); //item.channelList = item.channel ? (item.channel == "-1" ? [] : item.channel.split(",")): [];

                  item.server_rangeList = item.server_range ? item.server_range == "0" ? [] : item.server_range.split(",") : [];
                  item.pause = item.pause === 0 ? item.pause : item.pause ? item.pause : item.is_pause ? 0 : 1;
                  item.server_rangeList.map(function (i, ind) {
                    item.server_rangeList[ind] = parseInt(i);
                  });
                  var langLists = [];
                  item.main_content && item.main_content.forEach(function (j) {
                    langLists.push(_this4.langList.find(function (k) {
                      return k.value == j.language;
                    }).label);
                  });
                  item.language = langLists.toString();
                });
                _this4.tableCopyTableList = JSON.parse(JSON.stringify(list));
                _this4.tableData = _this4.currentChangePage(_this4.pageSize, _this4.currentPage);
                _this4.reqLoading = false;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    sendAnnounced: function sendAnnounced(id) {
      var _this5 = this;

      this.$confirm(this.$t('confirmSendAnnouncement'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var loading;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                loading = _this5.$loading({
                  lock: true,
                  text: _this5.$t('sending'),
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                sendAnnounce({
                  id: id,
                  is_prod: _this5.paramsData.is_prod,
                  game_id: _this5.rawData.game_id
                }).then(function (res) {
                  loading.close();

                  if (res.status == 200) {
                    _this5.$message({
                      type: "success",
                      message: _this5.$t('sendSuccess')
                    });

                    _this5.getList();
                  }
                }).finally(function () {
                  loading.close();
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    },
    // 删除配置
    handleDelete: function handleDelete(id, type) {
      var _this6 = this;

      this.$confirm(this.$t('confirmDeleteAnnouncement'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                reqFn = type == "old" ? delAnnounce : delAnnounceNew;
                reqFn(_objectSpread(_objectSpread({
                  ids: id
                }, _this6.paramsData), {}, {
                  game_id: _this6.rawData.game_id
                })).then(function (res) {
                  if (res.status == 200) {
                    _this6.getList();

                    _this6.$message({
                      type: "success",
                      message: _this6.$t('deleteSuccess')
                    });
                  }
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })));
    }
  }
};